module.exports = __webpack_public_path__ + "img/plus.dbdbabf0.svg";